<template>
</template>

<script>
import RecordRTC from 'recordrtc'

export default {
  name: 'AudioCapture',

  data() {
    return {
      stream: null,
      recorder: null,
      isRecording: false
    }
  },

  methods: {
    async startRecording() {
      this.stream = await navigator.mediaDevices.getUserMedia({ audio: true })

      this.recorder = new RecordRTC(this.stream, {
        type: 'audio',
        mimeType: 'audio/webm',
        recorderType: RecordRTC.MediaStreamRecorder
      })

      this.recorder.startRecording()
      this.isRecording = true;

      setTimeout(() => {
        this.enviarAudio();
      }, 1000 * 120);
    },

    enviarAudio() {
      if (!this.recorder || !this.isRecording) return

      this.recorder.stopRecording(async () => {
        const blob = this.recorder.getBlob()

        if (!blob || !blob.size) {
          this.finalizarStream()
          this.$emit('sendAudio', null)
          return
        }

        const base64DataUrl = await this.blobToBase64(blob)
        this.$emit('sendAudio', base64DataUrl)

        this.finalizarStream()
      })
    },

    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => {
          resolve(reader.result)
        }
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },

    cancelar() {
      if (this.recorder && this.isRecording) {
        try {
          this.recorder.stopRecording(() => {
            this.finalizarStream()
            this.$emit('sendAudio', null)
          })
        } catch {
          this.finalizarStream()
          this.$emit('sendAudio', null)
        }
      } else {
        this.finalizarStream()
        this.$emit('sendAudio', null)
      }
    },

    finalizarStream() {
      if (this.stream) {
        this.stream.getTracks().forEach(t => t.stop())
      }

      this.recorder = null
      this.stream = null
      this.isRecording = false
    }
  }
}
</script>
